import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import React from 'react'

interface iModalConfirm {
  open: boolean,
  setOpen: (open: boolean) => void
  onConfirm: () => void
  title: string
  text?: string
  cancelLabel?: string,
  confirmLabel?: string
  closeOnConfirm?: boolean
}

const ModalConfirm = ({
  open,
  setOpen,
  onConfirm,
  title,
  text,
  confirmLabel = 'Ano',
  cancelLabel = 'Zrušit',
  closeOnConfirm
}: iModalConfirm) => {

  const handleClose = () => {
    setOpen(false)
  }

  const handleConfirm = () => {
    onConfirm()
    if (closeOnConfirm) {
      setOpen(false)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      {text &&
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
        </DialogContent>
      }
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {cancelLabel}
        </Button>
        <Button onClick={handleConfirm} color="primary" autoFocus>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalConfirm
